import type { UpdateOnChangeProps } from './legacy';

export const UNSAFE_UpdateOnChange = (_props: UpdateOnChangeProps): null => null;
